export const NotFoundPage = () => {
  return <h1>Такой страницы не существует</h1>;
};
